<template>
  <div>
    <template>
      <ul class="nav">
        <li :class="[lang]">{{ $t("Invoice") }}</li>
      </ul>
    </template>
    <a-spin size="large" :spinning="loading">
      <div class="wrap-table">
        <a-table class="custom-scrollbar" size="middle" :columns="columns" :rowKey="(record, index) => index"
          :data-source="tableData" :pagination="false" :row-class-name="(_record, index) => (index % 2 !== 1 ? 'table-bg' : null)
            " :customRow="(record) => {
              return {
                on: {
                  click: () => goDetail(record),
                },
              };
            }
              ">
          <template slot="payType" slot-scope="text, record" class="arial">
            <span>{{
              record.duration_type == 2
                ? $t("AnnualPayment")
                : record.duration_type == 3
                  ? $t("MonthlyPayment")
                  : $t("InvoiceFree")
            }}</span>
          </template>

          <template slot="action" slot-scope="text, record" class="arial">
            <a href="javascript:void(0)" @click="downloadPdf(record)"><a-icon type="download" /> PDF</a>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: true,
      tableData: [],
      loading: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == "/sales/salesReps/campaignDetail") {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
      console.log(to, from);
    },
    lang() {
      this.getData();
    },
  },
  computed: {
    currentPath: {
      get() {
        return this.$route.path;
      },
    },
    columns: {
      get() {
        // let that = this;
        return [
          {
            title: this.$t("InvoiceNo"),
            dataIndex: "invoice_no",
            align: "center",
            width: 250,
          },
          {
            title: this.$t("InvoiceDate"),
            dataIndex: "date",
            align: "center",
          },
          {
            title: this.$t("InvoicePlan"),
            dataIndex: "plan",
            align: "center",
          },
          {
            title: this.$t("InvoiceAmount"),
            dataIndex: "amount",
            align: "center",
            customRender: function (text, record) {
              return "$" + record.amount.toFixed(2);
            },
          },
          // {
          //     title: 'Status',
          //     dataIndex: "status",
          //     align: "center",

          // },

          {
            title: this.$t("InvoiceDownload"),
            align: "center",
            fixed: "right",
            width: 200,
            scopedSlots: {
              customRender: "action",
            },
          },
        ];
      },
    },
    getEndTime() {
      let { end_date } = (this.user && this.user.free_info) || {};
      return Date.now() > new Date(end_date).getTime(); // 过期
    },
  },
  i18n: require("../i18n"),
  created() {
    //this.showMenu = this.showMenu2();
    this.getData();
  },
  methods: {
    async download(url, fileName = 'document.pdf') {
      try {
        // 1. 请求 PDF 文件
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        // 2. 获取 Blob 数据，MIME 类型为 application/pdf
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        // 3. 创建临时 <a> 标签触发下载
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;   // 指定下载文件名
        document.body.appendChild(link);
        link.click();

        // 4. 清理内存
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('下载 PDF 失败:', error);
        // 可在此添加用户提示（如 alert 或 toast）
      }
    },
    downloadPdf(record) {
      this.loading = true;
      this.$axios("/payment/download_invoice", { order_id: record.order_id }, "post").then((res) => {
        this.loading = false;
        if (res.code == 200 && res.data.info_status) {
          // this.download(res.data.pdf_url, `invoice_${record.order_id}.pdf`);
          window.open(res.data.url);
        } else if (res.code == 200 && !res.data.info_status) {
          let that = this;
          this.$confirm({
            title: this.$t("CompleteInfo"),
            onOk() {
              that.$router.push({
                path: "/setting/billingInformation",
              });
            }
          })
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    bindHandler(record) {
      console.log(record);
      let { id, campaign_type } = record;
      this.$router.push({
        path: "/setting/bindAccount",
        query: { id, campaign_type },
      });
    },
    getData() {
      this.loading = true;
      this.$axios("/payment/invoice_list", {}, "post").then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
        this.loading = false;
      });
    },
    goback() {
      this.$router.go(-1);
    },
    showMenu2() {
      if (this.$route.path == "/sales/salesReps/dialogue") {
        return false;
      } else if (this.$route.path == "/sales/salesReps/createCampaign") {
        return false;
      } else if (this.$route.path == "/sales/salesReps/campaignDetail") {
        return false;
      } else {
        return true;
      }
    },
    goDetail() { },
    // 继续进入 绑定linkindin 第二步
    continueSetp2(record) {
      this.$router.push({
        path: "/setting/bindAccount",
        query: {
          id: record.id,
          campaign_type: record.campaign_type,
          timezone_config_id: record.timezone_config_id,
          country_config_id: record.country_config_id,
          linkedin_id: record.linkedin_id,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.wrap-table {
  margin: 80px 30px 30px 30px;
  padding: 35px 30px 30px 30px;
  background: #fff;
  min-height: 690px;
}

.nav {
  width: 100%;
  padding-top: 7px;
  padding-left: 30px;
  border-top: #d1d1d1 solid 1px;

  li {
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    margin-right: 88px;
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
    color: #000000;

    a {
      color: #000;
    }

    border-bottom: #fff 2px solid;
  }

  .selected {
    border-bottom: #0e756a 2px solid;

    a {
      font-weight: bold;
    }
  }

  background: #ffffff;
  box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
}

.nav,
.back {
  left: 254px;
  position: fixed;
  top: 64px;
  right: 0;
  z-index: 200;
}

.back {
  border-top: #d1d1d1 solid 1px;
  color: #0e756a;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  padding-left: 30px;
  background: #fff;
}
</style>
